import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
import {
  ImpactDedicatedClinicLanzkronImage,
  ScdDayHospitalBenjaminImage
} from 'assets'

// TODO: Extract PdfDownloadLink to a shared component and import it.
// import { PdfDownloadLink } from '../../components/PdfDownloadLink'

// TODO: Get actual hosting link for the PDF and video.
const PDF_ACUTE_PAIN_INFUSION_VS_ED_URL = '#' // Placeholder
const VIDEO_ESTABLISHING_SCD_CLINIC_URL = '#' // Placeholder, consider embedding or linking

export const ClinicsEducationalResourcesPage: React.FC = () => {
  return (
    <ToolkitPageLayout
      title="Educational Resources (Clinics)"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Clinics', path: '/toolkit/clinics' },
        {
          label: 'Educational Resources',
          path: '/toolkit/clinics/educational-resources'
        }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg italic mb-8">
          The goal is to understand the impact of a dedicated infusion clinic
          for individuals living with sickle cell disease. The impact of an IC
          is direct access to high-quality care and a decreased need for
          hospital admissions.
        </p>

        <hr className="my-8" />

        <h2 className="text-2xl font-semibold text-[#142841] mt-8 mb-6">
          Read the following articles:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          {/* Article 1 */}
          <div className="flex flex-col items-center text-center p-4 border border-gray-200 rounded-lg shadow-lg bg-white">
            <a
              href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4409504/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact of a Dedicated Infusion Clinic for Acute Management of Adults with Sickle Cell Pain Crisis, article by Sophie Lanzkron, MD"
            >
              <img
                src={ImpactDedicatedClinicLanzkronImage}
                alt="Image linking to Impact of a Dedicated Infusion Clinic article"
                className="mb-3 rounded-lg shadow-md h-56 w-full object-contain"
              />
              <p className="text-lg font-medium text-[#A6410A] hover:text-[#894d35]">
                <em>
                  Impact of a Dedicated Infusion Clinic for Acute Management of
                  Adults with Sickle Cell Pain Crisis
                </em>
                , Sophie Lanzkron, MD
              </p>
            </a>
          </div>

          {/* Article 2 */}
          <div className="flex flex-col items-center text-center p-4 border border-gray-200 rounded-lg shadow-lg bg-white">
            <a
              href="https://ashpublications.org/blood/article/95/4/1130/138683/Sickle-cell-anemia-day-hospital-an-approach"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Sickle cell anemia day hospital: an approach for the management of uncomplicated painful crises, article by Lennette J. Benjamin"
            >
              <img
                src={ScdDayHospitalBenjaminImage}
                alt="Image linking to Sickle cell anemia day hospital article"
                className="mb-3 rounded-lg shadow-md h-56 w-full object-contain"
              />
              <p className="text-lg font-medium text-[#A6410A] hover:text-[#894d35]">
                <em>
                  Sickle cell anemia day hospital: an approach for the
                  management of uncomplicated painful crises
                </em>
                , Lennette J. Benjamin
              </p>
            </a>
          </div>
        </div>

        {/* PDF Download Link */}
        <div className="mb-8 p-4 border border-gray-200 rounded-lg shadow-md bg-white">
          <h2 className="text-2xl font-semibold text-[#142841] mt-8 mb-6">
            Related Document
          </h2>
          <a
            href={PDF_ACUTE_PAIN_INFUSION_VS_ED_URL}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#A6410A] hover:bg-[#894d35] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#A6410A] transition-colors duration-200"
          >
            {/* TODO: Add PDF icon if available in assets */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z"
                clipRule="evenodd"
              />
            </svg>
            Treatment of Acute Pain in Infusion Center vs. ED (PDF)
          </a>
          <p className="text-sm text-gray-600 mt-1">
            TODO: Update with actual Dropbox link.
          </p>
        </div>

        {/* Video Presentation */}
        <div className="mb-8 p-4 border border-gray-200 rounded-lg shadow-md bg-white">
          <h2 className="text-2xl font-semibold text-[#142841] mt-8 mb-6">
            Listen to the presentation on Establishing a SCD Infusion Clinic:
          </h2>
          {/* TODO: Replace with a proper video embed or styled link if a public URL is found */}
          {VIDEO_ESTABLISHING_SCD_CLINIC_URL &&
          VIDEO_ESTABLISHING_SCD_CLINIC_URL !== '#' ? (
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                src={VIDEO_ESTABLISHING_SCD_CLINIC_URL} // This would be an embeddable URL
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Presentation on Establishing a SCD Infusion Clinic by Mandy S. David, MPH, PA-C"
              ></iframe>
            </div>
          ) : (
            <p className="text-gray-700">
              Video presentation by Mandy S. David, MPH, PA-C.
              <br />
              <em className="text-sm">
                (TODO: Upload video or find public link and update placeholder)
              </em>
            </p>
          )}
        </div>

        <hr className="my-12" />

        <div className="mt-12 mb-8 text-center">
          <Link
            to="/toolkit/clinics"
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Clinics screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
